module.exports = __webpack_public_path__ + "img/eur.193ede75.svg";